var util = require('../util');

export default class FixIt{
	constructor(options) {
		this.options = options;

		this.enabled = this.options.enabled || function() {return true;};
		this.offset = this.options.offset || 0;
		this.target = this.options.target || false;

		if( this.enabled() && this.target ) {

			this.setPlaceholder();

			this.parentContainer = this.options.containedInParent ? (this.options.containedInParent.nodeType === 1 ? this.options.containedInParent : this.target.parentNode) : false;

			if(this.options.respondToParent) {
				this.options.respondToParent = this.options.respondToParent.nodeType === 1 ? this.options.respondToParent.nodeType : this.target.parentNode;

				window.addEventListener('resize', this.respondTo.bind(this));
			}
			
			window.addEventListener('scroll', this.updateStickyStatus.bind(this));

			this.scrollPosition = 0;
			this.updateStickyStatus();
		}
	}

	/**
	 * Updates the status of the sticky object according to where it is on the current scroll.
	 */
	updateStickyStatus() {
		var placeholderRect = this.placeholder.getBoundingClientRect(),
			canContainInParent = !this.parentContainer || (this.getTargetHeight() < this.parentContainer.getBoundingClientRect().height);

		let scrollDir = this.getScrollDirection();

		//canContainInParent if target is smaller than its parent
		//Make sure the entirety of the target element is visible on screen before applying the fixed status.
		if (placeholderRect.top < this.offset && canContainInParent) {

			if( !this.targetIsTall() ) {
				if(!this.isActive) {
					this.setActive();
				}
			}

			else {
				if (scrollDir === 'down') {
					if( Math.floor(this.target.getBoundingClientRect().bottom) <= document.body.offsetHeight ) {
						if(!this.isActive) {
							this.isFrozen = false;
							this.setActive(true);
						}
					}
					//We don't wanna run this if it's docked
					else if(this.isActive && !this.isDocked) {
						this.isActive = false;
						this.setFrozen();
					}
				}

				else {
					if( this.target.getBoundingClientRect().top >= this.offset ) {
						if(!this.isActive) {
							this.isFrozen = false;
							this.setActive();
						}
					}
					//We don't wanna run this if it's docked
					else if(this.isActive && !this.isDocked) {
						this.isActive = false;
						this.setFrozen();
					}
				}
			}

			this.containInParent();
		}

		else if(this.isActive) {
			this.isActive = false;
			this.setInactive();
		}

		return this.isActive || this.isFrozen;
	}

	/**
	 * Constrains the target element's scroll to the inside of a defined parent [parentContainer] element.
	 */
	containInParent() {
		if(!util.isMobile() && this.parentContainer && this.isActive) {
			let parentBottom = this.parentContainer.getBoundingClientRect().bottom,
				placeholderRect = this.placeholder.getBoundingClientRect(),
				targetRect = this.target.getBoundingClientRect();

			//Make sure bottom of parent is visible, then ensure the target and the parent's bottom are at the same level, then confirm the window's offset is not over the target
			if(parentBottom <= document.body.offsetHeight && targetRect.bottom >= parentBottom && targetRect.top <= this.offset ) {
				this.setDocked();
			}

			else if(this.isDocked && targetRect.top >= this.offset){
				this.setUndocked();
			}
		}
	}

	setDocked() {
		this.isDocked = true;
		this.target.classList.add('fixit--docked');
		this.target.classList.remove('fixit--bottom');
		this.setTargetPos(true);
	}

	setUndocked() {
		this.isDocked = false;
		this.target.classList.remove('fixit--docked');
		this.setTargetPos();
	}

	/**
	 * Either sets the target's 'top' property to the offset value, or clears it depending on [reset] value. 
	 * @param  {[boolean]} reset 
	 */
	setTargetPos(reset) {
		let newPos = '';

		if(!reset && this.options.useOffsetOnTarget) {
			newPos = this.offset + 'px';
		}

		this.target.style.top = newPos;
	}

	/**
	 * Adapts target's width according to its parent's width. Needed cause fixed elements respond to the window.
	 */
	respondTo() {
		if(this.isActive || this.isFrozen) {
			var parentComputedStyle = window.getComputedStyle(this.options.respondToParent),
			parentWidth = this.options.respondToParent.getBoundingClientRect().width - parseFloat(parentComputedStyle['padding-left']) - parseFloat(parentComputedStyle['padding-right']);
			this.target.style.width = parentWidth + 'px';
		}
	}


	/**
	 * Freezes the target at its current position relative to its parent.
	 */
	setFrozen() {
		this.isFrozen = true;
		this.target.style.top = Math.abs(this.parentContainer.getBoundingClientRect().top - this.target.getBoundingClientRect().top) + 'px';
		this.target.classList.remove('fixit--bottom');
		this.target.classList.remove('fixit--active');
		this.target.classList.add('fixit--frozen');
	}

	/**
	 * If 'toBottom' is set to true, the fixed element is attached to the bottom of its container.
	 * @param {[type]} toBottom [description]
	 */
	setActive(toBottom) {
		this.isActive = true;
		this.setPlaceholderProps(true);
		this.target.classList.remove('fixit--frozen');
		this.target.classList.add('fixit--active');

		if(toBottom) {
			this.target.classList.add('fixit--bottom');
			this.setTargetPos(true);
		}

		else {
			this.setTargetPos();
		}

		if(this.options.respondToParent) {
			this.respondTo();
		}
	}

	//Removes all statuses/settings from the fixit object
	setInactive() {
		this.setPlaceholderProps();
		this.target.classList.remove('fixit--active');
		this.target.classList.remove('fixit--bottom');
		this.target.classList.remove('fixit--docked');
		this.target.classList.remove('fixit--frozen');

		if(this.options.useOffsetOnTarget) {
			this.setTargetPos(true);
		}

		if(this.options.respondToParent) {
			this.target.style.width = '';
		}
	}

	/**
	 * Creates a "placeholder" element that will take the height (including padding) and margin properties of
	 * the target element and is used to avoid a jump when scrolling down and activating the 'fixed' status
	 */
	setPlaceholder() {
		let target = this.target;
		
		this.placeholder = document.createElement('div');

		this.placeholder.className = 'fixit-placeholder';

		target.parentNode.insertBefore(this.placeholder, target);
	}

	/**
	 * Updates placeholder properties
	 * @param {[boolean]} sync [either sets or resets values]
	 */
	setPlaceholderProps(sync) {
		if(sync) {
			this.placeholder.style.height = this.getTargetHeight() + 'px';
			this.placeholder.style.margin = window.getComputedStyle(this.target).margin;
			this.placeholder.fixitActive = true;
		}

		else {
			this.placeholder.style.height = '';
			this.placeholder.style.margin = '';
			this.placeholder.fixitActive = false;
		}
	}

	targetIsTall() {
		return (this.getTargetHeight() + this.offset) > document.body.offsetHeight;
	}

	getTargetHeight() {
		return this.target.getBoundingClientRect().height;
	}

	//This method needs revision:
	//Position is not properly reported on certain browsers when using window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	getScrollDirection() {
		let direction,
			docScrollTop = this.placeholder.getBoundingClientRect().top;

		if((this.scrollPosition > docScrollTop)) {
			direction = 'down';
		}

		else {
			direction = 'up';
		}

		this.scrollPosition = docScrollTop;

		return direction;
	}

}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.fixit.js